import React, { Component } from 'react';
import api from "./../../../services/api";
import './../../../pages/Representante_Instituição/TelaPerfilRI/styles.css';
//import { NavLink } from 'react-router-dom';
//import GetName from './GetName';
import {agent} from '../../../services/api';

let apiAgent = new agent();

var token = localStorage.getItem('user_token');
var RI_ID = localStorage.getItem("id_agent");

//Classe para API
export default class DisplayInfoRIPerfil extends Component {
    state = {
        info: [],
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        const request = await apiAgent.getAgent(RI_ID);
        console.log(request);
        console.log(request.data);
        this.setState({ info: request.data });

    };

    render() {
        return (
            <>
                <div id="MainPsPerfil">
                    {this.state.info.map(info => (
                        <>
                            <p id="RIDisplayInfo">Nome:<p>{info.name}</p></p>
                            <p id="RIDisplayInfo">Email:<p>{info.email}</p></p>
                            <p id="RIDisplayInfo">Gênero: <p>{info.gender}</p></p>
                            <p id="RIDisplayInfo">Data de nascimento: <p>{info.birth}</p></p>
                            <p id="RIDisplayInfo">Número de telefone: <p>{info.phone}</p></p>
                            <p id="RIDisplayInfo">CPF: <p>{info.cpf}</p></p>
                            <p id="RIDisplayInfo">Endereço da instituição: <p>{info.institucion_adress}</p></p>
                            <p id="RIDisplayInfo">Nome da instituição: <p>{info.institucion_name}</p></p>                            
                        </>
                    ))}
                </div>
            </>

        );
    }

}
